module.exports = __webpack_public_path__ + "media/images/andera-ecb9565f.png";